/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

/*
 * DO NOT FOREGET TO UPDATE './index.js' for the Amplify ColorSet
 */

/*
 * https://material-ui.com/customization/theming/
 * unstable_createMuiStrictModeTheme(options, ...args) => theme
 * WARNING: Do not use this method in production.
 * Generates a theme that reduces the amount of warnings inside React.StrictMode like Warning: findDOMNode is deprecated in StrictMode.
 */
import { blueGrey, blue, green, orange, red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";
import "./assets/typekit.css";

export const Branding = {
	appName: "Amplify Identity Broker",

	primary: red[900], // #263238,
	secondary: blueGrey[300], // #90a4ae,
	accent: orange[500], // #ff9800

	neutral: blueGrey[50], // #eceff1
	positive: green[700], // #689f38
	negative: red[700], // #d32f2f
	info: blue[700], // #1976d2
	warning: orange[700], // #f57c00

	cardHeaderColorPrimary: blueGrey[100], // #cfd8dc
	cardHeaderColorAccent: orange[500], // #ff9800

	white: "#fff", // #fff
	black: "#000", // #000

	opacityHover: 0.85,
};

// export const theme = unstable_createMuiStrictModeTheme({
export const theme = createTheme({
	palette: {
		primary: {
			light: "#22b970",
			main: "#17af66",
			dark: "#0c7f47",
			contrastText: "#ffffff",
		},
		secondary: {
			light: "#3d656c",
			main: "#103b41",
			dark: "#00161b",
			contrastText: "#fff",
		},
	},
	typography: {
		button: {
			textTransform: "none",
		},
		fontFamily: [
			"proxima-nova",
			"Inter",
			"Helvetica Neue",
			"Roboto",
			"Arial",
			"sans-serif",
		].join(","),
	},
	spacing: 8,
	breakpoints: {
		values: {
			xs: 0,
			sm: 740,
			password: 704,
			md: 960,
			lg: 1280,
			xl: 1920,
		},
	},
	components: {
		MuiOutlinedInput: {
			defaultProps: {
				color: "secondary",
			},
		},
		MuiTextField: {
			defaultProps: {
				color: "secondary"
			}
		},
		// Name of the
		MuiButton: {
			styleOverrides: {
				root: {
					boxShadow: "none",
					transitionDuration: "0.3s",
					transitionTimingFunction: "ease",
					transitionProperty:
						"background,background-color,background-position,border,box-shadow,color,opacity,transform,visibility",
					textDecoration: "none",
					fontWeight: 600,
				},
			},
		},
		MuiLink: {
			styleOverrides: {
				root: {
					textDecoration: "none",
					cursor: "pointer",
					transitionDuration: "0.3s",
					transitionTimingFunction: "ease",
					transitionProperty: "color",

					"&:hover": {
						color: "#107947",
						transitionDuration: "0.3s",
						transitionTimingFunction: "ease",
						transitionProperty: "color",
					},
				},
			},
		},
		MuiTelInput: {
			styleOverrides: {
				root: {
					color: "red",
				},
			},
		},
	},
});
